// Editable fields from the Operational Lookup API handoff.
const fields = [
    {
        "name": "name",
        "label": "Name",
        "type": "text",
        "required": true,
        "maxLength": 100
    },
    {
        "name": "abbreviation",
        "label": "Abbreviation",
        "type": "text",
        "required": true,
        "maxLength": 20
    }
];
export default fields;
